module.exports = __webpack_public_path__ + "static/testimonial_person_1-2f924033501f6a2c1240ebf36fedef47.jpg";